/** Resolves a CSS length var (e.g. a calc()) to pixels via a probe element.
 *  Used to keep the floating dev widgets inside Telegram's safe area. */
export function readCssPx(varName: string): number {
	const probe = document.createElement('div')
	probe.style.cssText = `position:fixed;visibility:hidden;height:var(${varName},0px);`
	document.body.appendChild(probe)
	const px = probe.getBoundingClientRect().height
	probe.remove()
	return px
}

/** Default top-right anchor shared by the eruda entry button and the floating
 *  dev icon — just inside the top-right corner, below Telegram's controls. */
export function defaultDevWidgetPos(): { x: number; y: number } {
	return { x: window.innerWidth - 50, y: readCssPx('--header-safe-top') + 4 }
}
